import { getPrimaryTracker } from 'usage-tracker-container';
export const TRACKER_NAME = 'academy-common-lib';
const getStandaloneTracker = () => getPrimaryTracker(TRACKER_NAME);
class UsageTracker {
  trackStandalone(eventName, eventProps) {
    try {
      getStandaloneTracker().track('Learning Center', eventName, eventProps);
    } catch (e) {
      // getPrimaryTracker throws synchronously when the named tracker is not
      // registered (SSR, Storybook, future consumer that hasn't wired the
      // container). Log and swallow so a missing wire-up doesn't crash the UI.
      console.error(`academy-common-lib UsageTracker: tracker not registered. Call setPrimaryTracker(tracker, '${TRACKER_NAME}') at app boot.`, e);
    }
  }
}
export default new UsageTracker();